import React, { useEffect, useRef, useState } from "react";
import { Button, Modal } from "antd";
// import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
// import { authHeader } from '../../utils/utils';
// import { UrlConstants } from "../../utils/ApiConstants";
import { downloadUserReportRequest } from "../../screens/users/states/action";
import { useDispatch } from "react-redux";
import { FileExcelOutlined, FilePdfOutlined } from "@ant-design/icons";
import { Notification } from "../../components/notification/notification";
import { GetRequest } from "../../utils/api";
import CustomLoader from "../../components/loader";
import { Document, Page, pdfjs } from 'react-pdf';

// Set up the worker for react-pdf
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

interface Props {
  title?: string;
  src: any;
  alt: string;
  type?: string
  URLloaded?: boolean;
  modelOpen?: boolean;
  onPreviewClosed?: any;
}
const DocumentComponent: React.FC<Props> = ({
  title,
  src,
  type = "document",
  URLloaded = false,
  modelOpen,
  onPreviewClosed = () => { },
}) => {

  // console.log("Document domponent");
  // console.log(src, modelOpen);


  const [open, setOpen] = useState<boolean>();
  const imageUrl = useRef(src);
  const [loading, setLoading] = useState<boolean>(false);
  const [numPages, setNumPages] = useState(null);

  const dispatch = useDispatch();

  // const docs = [
  //   { uri: `${UrlConstants.BASE_URL}${src}${title}?access_token=${authHeader().Authorization}`, fileName: title }, // Remote file
  // ];

  // const headers = {
  //   "authorization": `${authHeader().Authorization}`
  // };

  // const isGenerateUrl = (): boolean => {
  //   if (src && src.includes("/generate-url")) {
  //     return true;
  //   }
  //   return false;
  // };

  // const getRequestHeaders = () => {
  //   if (isGenerateUrl()) {
  //     return headers;
  //   }
  //   return {};
  // }

  const fetchDocument = async () => {

    if (title && type === 'document' && !URLloaded) {

      try {

        const response = await GetRequest(src + title, 'blob');

        let blob = new Blob([response], { type: 'application/pdf' });

        imageUrl.current = URL.createObjectURL(blob);

      } catch (error) {
        Notification("error", "Failed to download Image")
      }
    }

  };

  const openDocument = (ev: any) => {
    ev.stopPropagation();
    setLoading(true);

    fetchDocument().then(() => {
      setLoading(false);
      setOpen(!open);
    });

  }

  const handleDownload = () => {

    fetch(imageUrl.current)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Failed to fetch file: ${response.statusText}`);
        }
        return response.blob(); // Convert response to Blob
      })
      .then((blob) => {
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.href = url;

        if(title && title.length > 0) {
          if(!title.includes(".pdf")) {
            link.download = title + ".pdf"; // Use the custom filename
          } else {
            link.download = title; // Use the custom filename
          }
        } else {
          link.download = "download.pdf"; // Use the custom filename
        }
        
        link.click();
        URL.revokeObjectURL(url); // Clean up the object URL
      })
      .catch((error) => {
        console.error("Error downloading file:", error);
      });
  };

  useEffect(() => {

    setOpen(modelOpen);

  }, []);

  // Handle PDF load success
  const onDocumentLoadSuccess = ({ numPages }: any) => {
    setNumPages(numPages);
  };


  return (
    <>


      {type === 'document' &&
        <>
          {/* below line is for cases when Icon is clicked in info card - it fetches document */}
          {(title && title.length > 0) && <>{loading ? <CustomLoader size="sm"></CustomLoader> : <FilePdfOutlined onClick={(ev) => openDocument(ev)} className="text-2xl m-2 PDF-icon" rev={undefined} />} </>}

          <Modal
            centered
            open={open}
            closable={false}
            onOk={() => setOpen(false)}
            onCancel={() => { setOpen(false); onPreviewClosed() }}
            width={1000}
            className="my-4"
            styles={{
              content: {
                backgroundColor: "#f2f2f2"
              }
            }}
            footer={[
              <div className="text-right record-details">
                {/* <Button color="primary" variant="outlined" className="mr-2" onClick={() => setOpen(false)}>
                  Close
                </Button> */}
                <Button type="primary" onClick={() => handleDownload()}>
                  Download
                </Button>
              </div>
            ]}
          >
            {/* <DocViewer
              documents={[{ uri: imageUrl.current }]}
              requestHeaders={getRequestHeaders()}
              initialActiveDocument={docs[1]}
              pluginRenderers={DocViewerRenderers}
              
              config={{
                header: {
                  disableHeader: true,
                  disableFileName: true,
                  retainURLParams: false,
                },
              }}
            /> */}
            <div style={{ overflowY: "auto", height: "80vh" }}>
              <Document
                file={(title && title.length > 0) ? imageUrl.current : src}
                onLoadSuccess={onDocumentLoadSuccess}
                className={"w-100"}
              >
                {Array.from(new Array(numPages), (el, index) => (
                  <div className="my-3 flex justify-content-center">
                    <Page key={`page_${index + 1}`} pageNumber={index + 1} width={900} />
                  </div>

                ))}
              </Document>
            </div>



          </Modal>
        </>
      }

      {type === "download" && (title &&
        <div onClick={(ev) => { ev.stopPropagation(); dispatch(downloadUserReportRequest(src + title)); }}>
          <FileExcelOutlined width={200} className="document-icon" rev={undefined} />
        </div>
      )}
    </>
  );
};

export default DocumentComponent
